const baseURL = process.env.REACT_APP_GOAPP_API_URL;

const api = {
  urlGetActivityHistory: `${baseURL}/contact/service/activity/`,
};

export default api;
